import React, { FC } from 'react';
import { FormControl, RadioGroup } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface FormInputRadioProps {
  name: string;
  options: JSX.Element;
}

export const FormInputRadio: FC<FormInputRadioProps> = ({ name, options }) => {
  const { control } = useFormContext();

  return (
    <FormControl component="fieldset">
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <RadioGroup value={value || ''} onChange={onChange} className="radio-group">
              {options}
            </RadioGroup>
          );
        }}
      />
    </FormControl>
  );
};
